import React from 'react'
import classNames from 'classnames/bind'

import styles from './info-icon.module.scss'

const cx = classNames.bind(styles)

export const InfoIcon =
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 50 50">
<rect x="-40" y="13.43" className={cx("st0")} width="130" height="22.82"/>
<text transform="matrix(1 0 0 1 21.3486 35.5796)" className={cx(["st1", "st2", "st3"])}>i</text>
<circle className={cx("st4")} cx="24.95" cy="25.25" r="19.75"/>
</svg>